(function () {
  var rootSelector = '.care-guide-v3';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getModal(fromEl) {
    var section = fromEl ? closest(fromEl, rootSelector) : null;
    if (section) {
      var local = section.querySelector('[data-care-guide-v3-modal]');
      if (local) return local;
    }
    return document.querySelector('[data-care-guide-v3-modal]');
  }

  function closeModal(fromEl) {
    var modal = getModal(fromEl);
    if (!modal) return;
    var video = modal.querySelector('.care-guide-v3-modal__video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    modal.classList.remove('is-video', 'is-info');
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.documentElement.classList.remove('care-guide-v3-modal-open');
  }

  function openModal(card, mode) {
    var modal = getModal(card);
    if (!modal || !card) return;

    var title = card.getAttribute('data-title') || '';
    var videoUrl = card.getAttribute('data-video-url') || '';
    var poster = card.getAttribute('data-poster') || '';
    var bodyTpl = card.querySelector('[data-care-guide-v3-body]');
    var titleEl = modal.querySelector('.care-guide-v3-modal__title');
    var bodyEl = modal.querySelector('[data-care-guide-v3-modal-body]');
    var mediaEl = modal.querySelector('[data-care-guide-v3-modal-media]');
    var video = modal.querySelector('.care-guide-v3-modal__video');
    var isVideo = mode === 'video' && !!videoUrl;

    modal.classList.toggle('is-video', isVideo);
    modal.classList.toggle('is-info', !isVideo);

    if (titleEl) titleEl.textContent = title;
    if (bodyEl) {
      bodyEl.innerHTML = bodyTpl ? bodyTpl.innerHTML : '';
      bodyEl.hidden = isVideo && !(bodyTpl && bodyTpl.innerHTML.trim());
    }
    if (mediaEl) mediaEl.hidden = !isVideo;

    if (video) {
      video.pause();
      if (isVideo && videoUrl) {
        if (poster) video.setAttribute('poster', poster);
        else video.removeAttribute('poster');
        video.src = videoUrl;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        video.removeAttribute('src');
        video.removeAttribute('poster');
        video.load();
      }
    }

    document.documentElement.classList.add('care-guide-v3-modal-open');
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  document.addEventListener('click', function (event) {
    var videoBtn = closest(event.target, '[data-care-guide-v3-open-video]');
    if (videoBtn) {
      event.preventDefault();
      openModal(closest(videoBtn, '[data-care-guide-v3-card]'), 'video');
      return;
    }

    var infoBtn = closest(event.target, '[data-care-guide-v3-open-info]');
    if (infoBtn) {
      event.preventDefault();
      openModal(closest(infoBtn, '[data-care-guide-v3-card]'), 'info');
      return;
    }

    if (closest(event.target, '[data-care-guide-v3-close]')) {
      event.preventDefault();
      closeModal(event.target);
      return;
    }

    var modal = closest(event.target, '[data-care-guide-v3-modal]');
    if (modal && event.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  document.querySelectorAll(rootSelector + ' [data-care-guide-v3-modal]').forEach(function (modal) {
    modal.addEventListener('close', function () {
      var video = modal.querySelector('.care-guide-v3-modal__video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      modal.classList.remove('is-video', 'is-info');
      document.documentElement.classList.remove('care-guide-v3-modal-open');
    });
  });
})();
